<div id="cy-webapp" class="bg_light cy-webapp">
  <router-outlet></router-outlet>
</div>